import { GroupState } from '@/composition/groups'
import config from '@/config'
import ContentReports from '@/models/ContentReports'
import BaseService from './BaseService'
import { requests } from './HTTPService'

const http = requests(config?.COMMUNITIES_SERVER_URL)

export default class ContentReportService extends BaseService<ContentReports> {
  protected basePath = ''
  model(): typeof ContentReports {
    return ContentReports
  }

  constructor(locationId: string) {
    super(locationId)
    this.basePath = `${locationId}/groups/${GroupState.state.groupData._id}/content-reports`
  }

  async reportContent(data: any): Promise<any> {
    const response = await http.post(`${this.endpoint}`, data)
    return response.data
  }

  async getReportedContent(
    _groupId: string,
    _locationId: string,
    query?: any
  ): Promise<any> {
    const response = await http.get(`${this.endpoint}`, {
      params: query,
    })
    return response.data
  }

  async getReportedComment(commentId: string): Promise<any> {
    const response = await http.get(`${this.endpoint}/comment/${commentId}`)
    return response.data
  }

  async keepReportedContent(reportedContentId: string): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/${reportedContentId}/keep`
    )
    return response.data
  }

  async removeReportedContent(
    reportedContentId: string,
    postId: string
  ): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/${reportedContentId}/${postId}/remove`
    )
    return response.data
  }
}
